import { CopyrightPolicy } from '../../policies/copyright-policy/copyright-policy';

export const CopyrightPage = () => <CopyrightPolicy />;
